import { ModalOverlay, ModalOverlayProps } from '@chakra-ui/react';
import React from 'react';

export const CmModalOverlay: React.FC<ModalOverlayProps> = ({
  children,
  ...rest
}) => {
  return <ModalOverlay {...rest}>{children}</ModalOverlay>;
};
